const isStringValid =
  (...predicates: ((str: string) => boolean)[]) =>
  (value?: string): value is string => {
    if (typeof value !== "string") return false;
    return predicates.every((predicate) => predicate(value));
  };

// Define predicates
const notEmpty = (str: string) => str !== "";
const notPreampEmpty = (str: string) => str !== "__EMPTY__";

export const isNonEmptyString = isStringValid(notEmpty, notPreampEmpty);

export const lowercaseFirstLetter = (str: string): string => {
  if (!str) return str;
  return str.charAt(0).toLowerCase() + str.slice(1);
};
